var map = {
	"./country01.jpg": "0824",
	"./country02.jpg": "2d35",
	"./country03.jpg": "c8fd",
	"./country04.jpg": "d3d1",
	"./country05.jpg": "2d5c",
	"./country06.jpg": "c531",
	"./country07.jpg": "9861",
	"./country08.jpg": "fe56",
	"./country09.jpg": "f14c",
	"./country10.jpg": "2a6f",
	"./country11.jpg": "eab6",
	"./country12.jpg": "4d8f",
	"./country13.jpg": "31a2",
	"./country14.jpg": "5be6",
	"./country15.jpg": "a250",
	"./country16.jpg": "dba9",
	"./country17.jpg": "7199",
	"./country18.jpg": "c1c3",
	"./country19.jpg": "c55f",
	"./country20.jpg": "8442"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0bf";